import React, { Component } from 'react';
import './BackpackGridItem.css';

import fileExtension from '../utils/file-extension.js';
import { BackpackFileTypes, fileType } from '../utils/file-type.js';

const FILE_THUMBNAIL_HOST = 'https://thumbnails.account.normalvr.com';

class BackpackGridItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCheckbox: false
    }
  }

  onMouseOver = (ev) => {
    ev.preventDefault();
    this.setState({ showCheckbox: true });
  }

  onMouseOut = (ev) => {
    ev.preventDefault();

    this.setState({ showCheckbox: false });
  }

  onCheckClick = (ev) => {
    const { onCheckClick } = this.props;
    ev.preventDefault();

    onCheckClick();
  }

  isPreviewable = (type) => {
    const previewableTypes = [BackpackFileTypes.Video, BackpackFileTypes.Photo];

    if (previewableTypes.find((t) => t === type)) {
      return true;
    }

    return false;
  }

  render() {
    let { showCheckbox } = this.state;
    let { alwaysShowCheckbox, checked, item, onClick } = this.props;
    let { length, filename, filehash } = item;
    let classNames = ['BackpackGridItem'];

    let lengthLabel;
    if (length) {
      classNames.push('has-timestamp');

      let minutes = `${Math.floor(length / 60)}`;
      let seconds = `${length - (minutes * 60)}`;

      // Pad the minutes number to be at least be two digits.
      let pad = "00";
      let secondsPadded = pad.substring(0, pad.length - seconds.length) + seconds;

      // Then, format as a timestamp
      lengthLabel = `${minutes}:${secondsPadded}`;
    }

    // Uncomment the block below to enable multiselection. Disabling for now.
    let checkboxClasses = ['multiselect-checkbox'];
    /* if (showCheckbox || alwaysShowCheckbox || checked) {
      checkboxClasses.push('is-visible');
    } */

    let thumbnailUrl = `${FILE_THUMBNAIL_HOST}/150x150/${filehash}`;

    return (
      <li className={classNames.join(' ')}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onClick={() => onClick(item)}>
        <input className={checkboxClasses.join(' ')} value={checked} onChange={this.onCheckClick} type="checkbox" />
        <img src={thumbnailUrl} alt="" />
        <span className="length-label">{lengthLabel}</span>
      </li>
    );
  }
}

export default BackpackGridItem;



// WEBPACK FOOTER //
// ./src/components/BackpackGridItem.js